import { GatsbyImage, getImage } from "gatsby-plugin-image";

import useDeviceDetect from "../../hooks/useDeviceDetect";

import * as Styles from "./uspsBlock/styles.module.scss";

function UspsBlock({ content }) {
  const { isMobile } = useDeviceDetect();

  const usps = content?.usp || [];

  if (usps.length === 0) {
    return null;
  }
  return (
    <div className={Styles.uspContainer}>
      <h2 className={Styles.uspTitle}>{content.title}</h2>
      <div className={Styles.uspBlocks}>
        {usps.map((item, i) => (
          <div key={`usp-block-${i}`} className={Styles.uspBlock}>
            <div className={Styles.uspIconBlock}>
              <GatsbyImage
                className={Styles.uspIcons}
                alt={item?.uspImage.altText}
                image={getImage(
                  isMobile
                    ? item?.uspImage.mobileImage?.gatsbyImageData
                    : item?.uspImage.desktopImage?.gatsbyImageData
                )}
              />
            </div>
            <p className={Styles.uspText}>{item.uspTitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UspsBlock;
